// src/features/records/services/edges/counts.js

import { db } from '../../../../firebase';
import { collection, getCountFromServer, query, where } from 'firebase/firestore';
import { LIFECYCLE_STATUS } from '../../constants';
import { requireUser } from '../utils/auth';

/**
 * Get count of records shared by specific users with current user.
 */
export async function getSharedRecordCounts(userIds) {
  const user = requireUser();

  if (!userIds || userIds.length === 0) {
    return new Map();
  }

  const currentUserId = user.uid;
  const counts = new Map();

  try {
    const accessibleRecordsRef = collection(db, 'users', currentUserId, 'accessibleRecords');

    const countPromises = userIds.map(async (userId) => {
      const q = query(
        accessibleRecordsRef,
        where('lifecycle', '==', LIFECYCLE_STATUS.ACTIVE),
        where('ownerId', '==', userId)
      );
      const countSnapshot = await getCountFromServer(q);
      return { userId, count: countSnapshot.data().count };
    });

    const results = await Promise.all(countPromises);

    results.forEach(({ userId, count }) => {
      counts.set(userId, count);
    });

    return counts;
  } catch (error) {
    console.error('Error getting shared record counts:', error);
    userIds.forEach((userId) => counts.set(userId, 0));
    return counts;
  }
}

/**
 * Get count of records shared with a specific group.
 */
export async function getGroupRecordCount(groupId) {
  const user = requireUser();

  if (!groupId) {
    return 0;
  }

  try {
    const accessibleRecordsRef = collection(db, 'users', user.uid, 'accessibleRecords');
    const q = query(
      accessibleRecordsRef,
      where('lifecycle', '==', 'active'),
      where('permission.sourcesGroupIds', 'array-contains', groupId)
    );
    const countSnapshot = await getCountFromServer(q);
    const data = countSnapshot.data();
    return data?.count || 0;
  } catch (error) {
    console.error('Error getting group record count:', error);
    return 0;
  }
}
